import React, { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Components/Applications/ECommerce/Common/FilterComponent";
import { useSelector } from "react-redux";
import { Badge, FormGroup, Input } from "reactstrap";
import { Badges, Image, P } from "../../AbstractElements";
import SvgIcon from "../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { deleteCategory } from "../../ReduxToolkit/Reducers/ProductsReducer";
import Swal from "sweetalert2";

export default function CategoryListTable({ setCategory }) {
  const { categories } = useSelector((state) => state.products);

  const categoryColumns = [
    {
      name: "",
      cell: () => (
        <FormGroup check>
          <Input className="checkbox-primary" type="checkbox" />
        </FormGroup>
      ),
      sortable: false,
      width: "3%",
    },
    {
      name: "Category Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => <p>{row.name}</p>,
      width: "30%",
    },
    {
      name: "Point Mode",
      selector: (row) => row.point_mode,
      sortable: true,
      cell: (row) => (
        <Badge color="secondary" pill>
          {row.point_mode === "per_item" ? "Per Item" : "Per Dollar"}
        </Badge>
      ),
      width: "12%",
    },
    {
      name: "Points Value",
      selector: (row) =>
        row.point_mode === "per_item"
          ? row.points_per_item
          : row.points_per_dollar,
      sortable: true,
      cell: (row) => {
        const value =
          row.point_mode === "per_item"
            ? parseFloat(row.points_per_item || 0).toFixed(2)
            : parseFloat(row.points_per_dollar || 0).toFixed(2);
        return <p>{value}</p>;
      },
      width: "15%",
    },
    {
      name: "Discount Allow?",
      selector: (row) => row.discount_enable,
      sortable: true,
      cell: (row) =>
        row.discount_enable ? (
          <Badge color="success">Yes</Badge>
        ) : (
          <Badge color="danger">No</Badge>
        ),
      width: "15%",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="product-action d-flex gap-2">
          <SvgIcon iconId="edit-content" onClick={() => setCategory(row)} />
          <SvgIcon iconId="trash1" onClick={() => handleDeleteCategory(row)} />
        </div>
      ),
      sortable: false,
      width: "15%",
    },
  ];

  const dispatch = useDispatch();

  const [filterText, setFilterText] = useState("");

  const filteredItems = categories.filter((item) => {
    return Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
    );
  });
  const handleDeleteCategory = async (cat) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--theme-red)",
      cancelButtonColor: "var(--theme-blue)",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const resp = await dispatch(deleteCategory(cat.term_id));
        if (resp.payload.success) {
          toast.success("Category Deleted");
        }
      } catch (error) {
        console.log(error);
        toast.error("Error Deleting Category");
      }
    }
  };
  return (
    <div className="list-product list-category">
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        filterText={filterText}
      />
      <DataTable
        className="custom-scrollbar"
        data={filteredItems}
        columns={categoryColumns}
        pagination
      />
    </div>
  );
}
